import { getStepRouteName } from '@/onboarding/routes/lib'
import { LocalOnboardingStep } from '@/onboarding/types'
import type { RouteRecordRaw } from 'vue-router'

export const fishOnboardingRoutes: RouteRecordRaw[] = [
  {
    path: 'onboarding',
    component: () => import('@/onboarding/components/layout.vue'),
    name: 'fish-onboarding',
    children: [
      {
        path: 'supported-area',
        name: getStepRouteName(LocalOnboardingStep.SupportedArea),
        component: () =>
          import('@/onboarding/components/steps/supported-area.vue'),
      },
      {
        path: 'autosubscribe',
        name: getStepRouteName(LocalOnboardingStep.Autosubscribe),
        component: () =>
          import('@/onboarding/components/steps/autosubscribe.vue'),
      },
    ],
  },
]
